import React from 'react';
import {observer} from 'mobx-react';
import {active_perm} from '../../activeVM.js';
import {vm_cache} from '../util/WebconnectFrame.js';
import {copilotControllers, getController, unregisterController} from '../../copilot/controllerRegistry';
import {getPermissionDisplayName} from '../../util/permissionName';


/**
 * Handle the sidebar 'X' click that closes a Guacamole connection.
 * If a Copilot session is bound to this connection (pinned via permission_id
 * at session start, per specs/2026-05-15-copilot-connection-pinning-design.md),
 * end it cleanly with end_reason='connection_closed'. When Copilot is
 * mid-task, prompt the user first — closing the connection silently while
 * the agent is working would orphan an in-flight task with no signal.
 *
 * Returns true if the close should proceed, false if the user cancelled
 * out of the mid-task confirmation.
 */
async function endPinnedCopilotForPerm(perm_id) {
  const ctrl = getController(perm_id);
  if (!ctrl || !ctrl.sessionId) return true;
  if (ctrl.isMidTask) {
    // window.confirm is intentionally lightweight — the styled modal pattern
    // used elsewhere (copilot-modal-*) would need state lifting and adds
    // surface area for a corner-case prompt. Swap to a styled modal if this
    // turns out to be common.
    const ok = window.confirm(
      'Copilot is working on this connection. Close it anyway? The agent will stop.'
    );
    if (!ok) return false;
  }
  try {
    await ctrl.stop('connection_closed');
  } catch (e) {
    // Network failure to /end is non-fatal — the idle sweep will close the
    // session server-side within 30 min. Don't block the user from closing
    // their connection over it.
    console.error('[Copilot] end-on-connection-close failed:', e);
  }
  unregisterController(perm_id);
  return true;
}


export const ActiveConnections = observer(() => {

  // Touch the registry observable up front so observer() re-renders when a
  // Copilot controller is registered/unregistered. Otherwise the badge would
  // not appear until some other render trigger fires.
  copilotControllers.size; // eslint-disable-line no-unused-expressions

  // Do not display if nothing is in the VM cache
  if([...vm_cache.entries()].length === 0) return null;

  const hasCopilotPinned = perm_id => {
    const c = getController(perm_id);
    return Boolean(c && c.sessionId);
  };


  return (

    <div className='scroll-inner'>
      <div className="computers-list" id="the-active-vms-list">
         <div className="accordion">
            <div className="card">
               <div className="card-header">
                  <h4 className="mb-0">
                     <i className="fa fa-desktop" aria-hidden="true" style={{color: "#fff"}}></i> Active Connections
                  </h4>
               </div>
            </div>
          </div>


          <ul className="computer-list list-items user-pc active-connections" id="active-connection-list">

            {

              [...vm_cache.keys()]
            //    .filter(perm_id => perm_id.startsWith('pool') || permission_list.get()[perm_id])
                .map(perm_id =>

                <li key={perm_id}
                  className="the-menu-parent active-connections"
                  style={{
                    backgroundColor: active_perm.get() === perm_id ? "#007bff" : "inherit",
                    display: 'flex',
                    whiteSpace: 'nowrap',
                    justifyContent: 'space-between'
                  }}>

                  <a href="#."
                    title={hasCopilotPinned(perm_id)
                      ? `${getPermissionDisplayName(perm_id)} — Copilot is running here`
                      : getPermissionDisplayName(perm_id)}
                    onClick={(e) => {
                      e.preventDefault()
                      active_perm.set(perm_id)
                    }}
                    style={{
                      overflow: 'hidden',
                      minWidth: 0,
                      textOverflow: 'ellipsis',
                      padding: '3px',
                      paddingLeft: '15px'
                    }}>
                    {hasCopilotPinned(perm_id) && (
                      <i
                        className="fa fa-magic"
                        aria-hidden="true"
                        title="Copilot is running on this connection"
                        style={{marginRight: '6px', color: '#ffd54f'}}
                      />
                    )}
                    {getPermissionDisplayName(perm_id)}
                  </a>

                  <div className="status-bar" id="status-bar">
                    <i className="fa-custom fa fa-times signout-button status-icon-bg-hover-only"
                      aria-hidden="true"
                      title="Close"
                      style={{paddingRight: '6px'}}
                      onClick={async e => {

                        // to refresh:
                        // active_perm.set(); active_perm.set(perm_id);

                        const proceed = await endPinnedCopilotForPerm(perm_id);
                        if (!proceed) return;

                        vm_cache.delete(perm_id);
                        if(active_perm.get() === perm_id) active_perm.set();

                      }}>
                    </i>
                  </div>
                </li>

              )

            }

          </ul>

       </div>
    </div>

  );

})
